
import { Component, Prop, Vue } from "vue-property-decorator";
import store from "../../core/store";

@Component
export default class TestimonialCard extends Vue {
  @Prop({ required: true }) private testimonial!: any;
  @Prop({ required: true }) private index!: number;

  private get isDarkMode() {
    return store.state.settings.DarkMode === true;
  }

  private getImageType(name: string, index: number) {
    if (name !== undefined && name !== "" && name !== null) {
      return store.state.settings.Uploads + "/" + name;
    }
    return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
  }

  getPlainDetail(html: string): string {
    if(html == null){
      return "";
    }
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  }
}
